module.exports = __webpack_public_path__ + "02_medium_gray.8f5221fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_medium_gray.png
// module id = uAtt
// module chunks = 0